import fp from "lodash/fp";
import moment from "moment";

import { withResetState } from "store/hocs";

import { sourceFilterFilesConstants } from "./filterFiles.constants";

const currentYear = moment().year();
const currentMonth = moment().month() + 1;

const initialState = {
	sourceFilesFilters: {
		paidMonth: currentMonth,
		paidYear: currentYear,
		searchFor: "",
	},
	importSourceDataFilters: {
		paidMonth: currentMonth,
		paidYear: currentYear,
		searchFor: "",
	},
	normalizationFilters: {
		paidMonth: currentMonth,
		paidYear: currentYear,
		searchFor: "",
	},
};

export const getSourceFilterFilesConstantsState = state =>
	state.sourceFilterFiles;

//prettier-ignore
const selector = property =>
	fp.flow(getSourceFilterFilesConstantsState, fp.property(property));

export const getSourceFilesFilters = selector("sourceFilesFilters");
export const getImportSourceFilters = selector("importSourceDataFilters");
export const getNormalizationFilters = selector("normalizationFilters");

export function sourceFilterFiles(state = initialState, action) {
	switch (action.type) {
		case sourceFilterFilesConstants.RESET_FILTERS: {
			return {
				...state,
				queryParams: {
					...state.queryParams,
					pageIndex: 0,
				},
				filters: initialState.filters,
			};
		}
		case sourceFilterFilesConstants.SET_FILTERS: {
			const setValueInTab = () => {
				if (action.tab === "source-files") {
					return {
						...state,
						sourceFilesFilters: {
							...state.filters,
							...action.filters,
						},
					};
				} else if (action.tab === "import-source-data") {
					return {
						...state,
						importSourceDataFilters: {
							...state.filters,
							...action.filters,
						},
					};
				} else {
					return {
						...state,
						normalizationFilters: {
							...state.filters,
							...action.filters,
						},
					};
				}
			};
			return setValueInTab();
		}
		case sourceFilterFilesConstants.REMOVE_FILTER: {
			return fp.unset(`filters.${action.filterName}`, state);
		}

		default:
			return state;
	}
}

export default withResetState({ initialState })(sourceFilterFiles);
